import { get } from 'lodash'

import { getTranslatedString, ConditionReport, SignerResource, GenericAlterationResource, CounterSignatureResource, ReportEditorResource, TypeOfPackagingResource, TranslatedString } from '@skinsoft/types'

export const id = (conditionReport: ConditionReport) => get(conditionReport, 'id');

export const media = (conditionReport: ConditionReport) => {
    const otherMedia = get(conditionReport, 'associatedMedias.mediaFiles.0.mediaId', null);
    const third = get(conditionReport, 'associatedMedias.third');
    const second = get(conditionReport, 'associatedMedias.second');
    const first = get(conditionReport, 'associatedMedias.first');

    return first || second || third || otherMedia;
};

export const manifestation = (conditionReport: ConditionReport) =>
    get(conditionReport, 'linkToManifestation.referentManifestation');

// For search features
export const title = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'translatedTitle', ''), locale) as string;

// ============

export const medias = (conditionReport: ConditionReport) => {
    const mediasArray = get(conditionReport, 'associatedMedias.medias');
    return mediasArray ? mediasArray : [];
};

export const firstMedia = (conditionReport: ConditionReport) => get(conditionReport, 'associatedMedias.first')

export const referenceNumber = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.referenceNumber');

export const technicsAndMaterials = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.technicsAndMaterials[0]'), locale);

export const originalIdentifier = (conditionReport: ConditionReport) =>
    get(conditionReport, 'managementData.originalIdentifier');

export const reportReason = (conditionReport: ConditionReport) => get(conditionReport, 'conditionReportCS.reportReason')

// thesaurus term ref
export const reportType = (conditionReport: ConditionReport): string =>
    get(conditionReport, 'conditionReportCS.reportType')

export const status = (conditionReport: ConditionReport) => get(conditionReport, 'workflowSchema.currentState.name')


export const location = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.location'), locale);

export const date = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.reportDate.startInterval.dateTxt');

export const generalState = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.generalState'), locale)

export const defects = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.alterationDetails', []) || [];

export const recommendations = (conditionReport: ConditionReport, locale: string) =>
    getTranslatedString(get(conditionReport, 'conditionReportCS.recommendations'), locale)

export const workflowState = (conditionReport: ConditionReport): string => {
    return get(conditionReport, "workflowSchema.currentState.name") as string ??
        get(conditionReport, "workflowSchema.currentState.value")
}

export const comments = (conditionReport: ConditionReport, locale: string): string =>
    getTranslatedString(get(conditionReport, "conditionReportCS.comments[0]"), locale) as string

export const interventionsToSchedule = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.predictInterventions")

export const stateOfConservation = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.stateOfConservations")

export const treatmentPriority = (conditionReport: ConditionReport) =>
    get(conditionReport, "conditionReportCS.treatmentPriority")

export const involvedItem = (conditionReport: ConditionReport) =>
    get(conditionReport, 'conditionReportCS.linkableItem.linkableItem');

export const signers = (conditionReport: ConditionReport): SignerResource[] | undefined | null => {
    return get(conditionReport, 'conditionReportCS.signers', undefined)
}

export const reportEditors = (conditionReport: ConditionReport): ReportEditorResource[] => {
    return get(conditionReport, 'conditionReportCS.reportEditor', undefined)
}

export const alterations = (conditionReport: ConditionReport): GenericAlterationResource[] | undefined | null => {
    return get(conditionReport, 'conditionReportCS.alterations', undefined)
}

export const counterSignatures = (conditionReport: ConditionReport): CounterSignatureResource[] | undefined | null => {
    return get(conditionReport, 'conditionReportCS.counterSignatures', undefined)
}

export const typeOfPackaging = (conditionReport: ConditionReport): TypeOfPackagingResource | null | undefined => {
    return get(conditionReport, 'conditioningSchema.typeOfPackaging')
}

export const crateNumber = (conditionReport: ConditionReport): TranslatedString | null | undefined => {
    return get(conditionReport, 'conditioningSchema.crateNumber')
}

export const transportAccessories = (conditionReport: ConditionReport): TranslatedString[] | null | undefined => {
    return get(conditionReport, 'conditioningSchema.transportAccessories')
}